export type AccountEmailEventStep = 'form-cta-impression' | 'form-cta-click';

export type AccountEmailEvent = {
  name: 'email_capture';
  form_type: 'uw';
  form_name: 'sign-up | log-in';
  form_step_name: AccountEmailEventStep;
  form_step_details: 'log-in | sign-up' | 'user-icon';
  cta_text?: 'log-in | sign-up';
};

export type SaveProductCtaText = 'save' | 'icon-heart';

export type SaveProductEvent = {
  name: 'email_capture';
  form_type: 'uw';
  form_name: 'sign-up';
  form_step_name: 'form-cta-click';
  form_step_details: 'save-product';
  cta_text: SaveProductCtaText;
};

const ACCOUNT_EMAIL_BASE_EVENT = {
  name: 'email_capture' as const,
  form_type: 'uw' as const,
};

export const buildAccountEmailAuthEvent = (
  step: AccountEmailEventStep,
  isLoggedIn: boolean
): AccountEmailEvent => ({
  ...ACCOUNT_EMAIL_BASE_EVENT,
  form_name: 'sign-up | log-in',
  form_step_name: step,
  form_step_details: isLoggedIn ? 'user-icon' : 'log-in | sign-up',
  ...(isLoggedIn ? {} : { cta_text: 'log-in | sign-up' }),
});

export const buildSaveProductEvent = (
  ctaText: SaveProductCtaText
): SaveProductEvent => ({
  ...ACCOUNT_EMAIL_BASE_EVENT,
  form_name: 'sign-up',
  form_step_name: 'form-cta-click',
  form_step_details: 'save-product',
  cta_text: ctaText,
});

export type ViewFullReviewStep =
  | AccountEmailEventStep
  | 'form-open'
  | 'form-closed';

export type ViewFullReviewCtaText =
  | 'unlock-full-review'
  | 'continue-with-linkedin'
  | 'continue-with-google';

export const buildViewFullReviewCtaEvent = (
  step: ViewFullReviewStep,
  ctaText: ViewFullReviewCtaText = 'unlock-full-review'
) => ({
  ...ACCOUNT_EMAIL_BASE_EVENT,
  form_name: 'sign-up' as const,
  form_step_name: step,
  form_step_details: 'view-full-review' as const,
  cta_text: ctaText,
});
